/// <reference path="parallax.ts" />
function checkVideoSize(width, iframeClass, videoParallax, videoParallaxMobile) {
    if (width >= 768 && width <= 1200) {
        $(iframeClass + ' iframe').attr('height', videoParallax.getValue(width));
    }
    else if (width < 768) {
        $(iframeClass + ' iframe').attr('height', videoParallaxMobile.getValue(width));
    }
    else if (width > 1200) {
        $(iframeClass + ' iframe').attr('height', 585);
    }
}
jQuery('document').ready(function ($) {
    if ($('body').hasClass('single')) {
        /**
         * POPUP WITH SLIDER
         */
        var popupSwiper = null;
        var popupOpener = $('.popup__action');
        var popupCloserClass_1 = 'popup__close';
        var popupContainer_1 = $('.popup');
        popupOpener.on('click', function (e) {
            // e.preventDefault();
            $('body').addClass('noScroll');
            var isPopupOpened = popupContainer_1.hasClass('display');
            if (!isPopupOpened) {
                popupContainer_1.addClass('display');
                // If not, initialize the popup swiper
                if (popupSwiper === null) {
                    popupSwiper = new Swiper('.test', {
                        spaceBetween: 0,
                        speed: 600,
                        effect: 'fade',
                        loop: true,
                        pagination: {
                            el: '.swiper-pagination',
                            dynamicBullets: true,
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                    });
                }
                console.log('yo yo', popupSwiper);
                setTimeout(function () {
                    popupContainer_1.addClass('active');
                }, 100);
            }
            else {
                popupContainer_1.removeClass('active');
                setTimeout(function () {
                    popupContainer_1.removeClass('display');
                }, 300);
            }
        });
        popupContainer_1.on('click', function (event) {
            if (!hasSomeParentTheClass(event.target, 'window') || hasSomeParentTheClass(event.target, popupCloserClass_1)) {
                var isPopupOpened = popupContainer_1.hasClass('display');
                if (isPopupOpened) {
                    // Close
                    popupContainer_1.removeClass('active');
                    $('body').removeClass('noScroll');
                    setTimeout(function () {
                        popupContainer_1.removeClass('display');
                    }, 300);
                }
            }
        });
        /**
         * SLIDER HEADER
         */
        // Slider header if there is one
        if ($('.single__header .swiper-container').length > 0) {
            // console.log('onpasse');
            var headerSwiper = new Swiper('.single__header .swiper-container', {
                spaceBetween: 0,
                speed: 1000,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                loop: true,
                direction: 'horizontal',
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false,
                },
            });
        }
        /**
         * VIDEO PROPORtION LISTENERS
         */
        var videoResize = {
            name: 'videoResize',
            element: $('.single__content_video'),
            type: '',
            scrollValues: { min: 768, max: 1200 },
            parallaxValues: { min: 388, max: 630 }
        };
        var videoParallax_1 = new Parallax(videoResize);
        var videoResizeMobile = {
            name: 'videoResize',
            element: $('.single__content_video'),
            type: '',
            scrollValues: { min: 200, max: 767 },
            parallaxValues: { min: 97, max: 415 }
        };
        var videoParallaxMobile_1 = new Parallax(videoResizeMobile);
        checkVideoSize($(window).width(), '.single__content_video', videoParallax_1, videoParallaxMobile_1);
        $(window).on('resize', function () {
            checkVideoSize($(this).width(), '.single__content_video', videoParallax_1, videoParallaxMobile_1);
        });
    }
});
